module.exports = __webpack_public_path__ + "img/Hiromi-Sasaki.d2441703.jpg";